export const ADD_CAMERA_PARTICIPANT_REQUEST = 'camera-participant/ADD_CAMERA_PARTICIPANT_REQUEST';
export const ADD_CAMERA_PARTICIPANT_SUCCESS = 'camera-participant/ADD_CAMERA_PARTICIPANT_SUCCESS';
export const ADD_CAMERA_PARTICIPANT_FAILURE = 'camera-participant/ADD_CAMERA_PARTICIPANT_FAILURE';
export const REMOVE_CAMERA_PARTICIPANT_REQUEST = 'camera-participant/REMOVE_CAMERA_PARTICIPANT_REQUEST';
export const REMOVE_CAMERA_PARTICIPANT_FAILURE = 'camera-participant/REMOVE_CAMERA_PARTICIPANT_FAILURE';
export const REMOVE_CAMERA_PARTICIPANT_SUCCESS = 'camera-participant/REMOVE_CAMERA_PARTICIPANT_SUCCESS';
